import $ from "jquery"
import select2Factory from "select2/dist/js/select2.full.js"
select2Factory(window, $)
